import { Location } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SnRouteStackService {
  constructor(private readonly _location: Location) {}

  public back(): void {
    this._location.back();
  }

  public forward(): void {
    this._location.forward();
  }
}
